import { FC, memo, useMemo } from 'react';
import {
  IInteractiveNavChartTooltipItem,
  InteractiveNavChart,
  InteractiveNavChartTooltip,
  TNavChartRenderTooltip,
  usePeriods,
} from '@/components/InteractiveNavChart';
import { useGetStockAssetTrend } from '@/modules/invest/hooks/useGetNavChartData';

const renderTooltip: TNavChartRenderTooltip = (chart) => {
  const point1 = chart?.points?.[1];
  const point2 = chart?.points?.[2];

  const interactiveNavChartTooltipItems: IInteractiveNavChartTooltipItem[] = [
    {
      title: 'تاریخ',
      value: chart.x,
      type: 'date',
    },
    {
      title: 'ارزش دارایی',
      value: chart.y,
      type: 'amount',
      isZeroValueVisible: true,
    },
    {
      title: 'خرید',
      value: point1?.y,
      type: 'count',
      color: 'success',
    },
    {
      title: 'فروش',
      value: point2?.y,
      type: 'count',
      color: 'error',
    },
  ];

  return <InteractiveNavChartTooltip items={interactiveNavChartTooltipItems} />;
};

interface ISingleEtfAssetTrendNavChartProps {}

export const SingleEtfAssetTrendNavChart: FC<ISingleEtfAssetTrendNavChartProps> =
  memo(() => {
    const { periods, selectedPeriod, setSelectedPeriod } = usePeriods();

    const { data, isFetching, error, refetch } = useGetStockAssetTrend({
      fromMonthAgo: selectedPeriod.month,
    });

    const series = useMemo(
      () => [
        {
          name: 'Investment',
          color: '#80D3CB',
          type: 'area',
          data: data?.items?.map((item) => [item.d, item.a]),
        },
        {
          name: 'Issuance',
          color: 'transparent',
          type: 'line',
          data: data?.items?.map((item) => [item.d, item.iCh]),
        },
        {
          name: 'Redemption',
          color: 'transparent',
          type: 'line',
          data: data?.items?.map((item) => [item.d, item.reCh]),
        },
      ],
      [data?.items]
    );

    return (
      <InteractiveNavChart
        error={error}
        isEmpty={!data || data?.items.length < 2}
        isLoading={isFetching}
        periods={periods}
        renderTooltip={renderTooltip}
        selectedPeriod={selectedPeriod}
        series={series}
        startDate={data?.firstTransaction}
        onErrorRetry={refetch}
        onPeriodChange={setSelectedPeriod}
      />
    );
  });

SingleEtfAssetTrendNavChart.displayName = 'SingleEtfAssetTrendNavChart';
